<h1>Window not yet paired.</h1>
<p>
  It appears this window is not yet paired to another window. A window pair has to be created before
  continuing.
</p>
